<template>
    <span
        v-if="occupancy"
        class="d-flex align-items-center
">
        <span
            v-if="occupancy === 'free'"
            class="badge badge-pill badge-success occupancy-badge">
            Plätze verfügbar
        </span>
        <span
            v-else-if="occupancy === 'few'"
            class="badge badge-pill badge-warning occupancy-badge">
            Wenige Plätze verfügbar
        </span>
        <span
            v-else-if="occupancy === 'full' && registrationWhenFullyBooked"
            class="badge badge-pill badge-danger occupancy-badge">
            Warteliste
        </span>
        <span
            v-else-if="occupancy === 'full'"
            class="badge badge-pill badge-danger occupancy-badge">
            Plätze ausgebucht
        </span>
    </span>
</template>

<script>
import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";
import registrationOnlineRegistrationFieldsMixin
    from "@/mixins/registration/registrationOnlineRegistrationFieldsMixin";

export default {
    name: "OccupancyBadge",
    mixins: [mainRegistrationMixin, registrationOnlineRegistrationFieldsMixin],
    computed: {
        registrationWhenFullyBooked() {
            return this.eventData?.registrationWhenFullyBooked
        },
    }
}
</script>

<style lang="scss" scoped>
.occupancy-badge {
    color: $white;
    text-transform: none;

    &.badge-success {
        background-color: $success;
    }

    &.badge-danger {
        background-color: $danger;
    }

    &.badge-warning {
        background-color: $warning;
    }

    &.badge-info {
        background-color: $info;
    }
}
</style>
